import {getCsrfAndSessionToken} from './helpers';

window.giftRedemptionPreferences = {
    /**
     * Submit Account Form
     *
     * @param event
     */
    submit: function (event) {
        event.preventDefault();

        //
        // Set Loading
        //
        jQuery('[data-gift-redemption-preferences-cloak]').fadeIn();

        //
        // Clear Error Messages
        //
        let errorMapping = {
            'gift_redemption_preferences': 'gift-redemption-preferences',
        };

        for (let i = 0; i < Object.keys(errorMapping).length; i++) {
            let value = errorMapping[Object.keys(errorMapping)[i]];
            document.querySelector('[data-error-' + value +']').style.display = 'none';
            document.querySelector('[data-error-' + value +']').innerText = '';
        }

        getCsrfAndSessionToken()
            .then((token) => {

                if (!token) {
                    jQuery('[data-gift-redemption-preferences-cloak]').fadeOut();
                    alert('Could not get session token, please refresh the page and try again.');
                    return;
                }

                //
                // Get value
                //
                var value = null;
                if (document.querySelector('[data-input-gift-redemption-preferences]:checked')) {
                    value = document.querySelector('[data-input-gift-redemption-preferences]:checked').value;
                }

                return new Promise((resolve, reject) => {
                    fetch(window.loginEndpoint + '/redeem/preferences', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-XSRF-TOKEN': token,
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            gift_redemption_preferences: value,
                        }),
                    })
                        .then(response => {
                            if (response.ok) {
                                //
                                // Redirect
                                //
                                response.json().then(data => {
                                    jQuery('[data-gift-redemption-preferences-cloak]').hide();
                                    window.location.href = data.redirect;
                                })
                                    .catch((errors) => {
                                        console.error('Error:', errors);
                                    });

                                console.log(response);
                                resolve();
                            } else {
                                response.json().then(data => {
                                    console.log(data.errors, errorMapping);
                                    for (let i = 0; i < Object.keys(errorMapping).length; i++) {
                                        let key = Object.keys(errorMapping)[i];
                                        let value = errorMapping[Object.keys(errorMapping)[i]];

                                        if (key in data.errors) {
                                            let message = data.errors[key].join('. ');
                                            document.querySelector('[data-error-' + value +']').style.display = 'block';
                                            document.querySelector('[data-error-' + value +']').innerText = message
                                        }
                                    }
                                })
                                    .catch((errors) => {
                                        console.error('Error:', errors);
                                    });

                                //
                                // If we received errors, present them
                                //
                                /**/

                                reject();
                                //
                                // Set Loading
                                //
                                jQuery('[data-gift-redemption-preferences-cloak]').fadeOut();
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                            reject();
                            //
                            // Set Loading
                            //
                            jQuery('[data-gift-redemption-preferences-cloak]').fadeOut();
                        });
                });
            })
            .catch(() => {
                //
                // Set Loading
                //
                jQuery('[data-gift-redemption-preferences-cloak]').fadeOut();
            })
    },
}
